export const GOODS = 'goods'
export const REGION = 'showRegions'
export const GENDER = 'gender'
export const AGE = 'age'
export const ADVANTAGES = 'advantages'
export const PROMO_ACTION = 'promoAction'
export const CARD_EMAIL = 'vcardEmail'
export const CARD_PHONE = 'vcardPhone'
export const CARD_CITY = 'vcardCity'
export const CARD_ADDRESS = 'vcardAddress'
export const CARD_WORKING_DAY = 'vcardWorkingDay'
export const CARD_WORKING_START_TIME = 'vcardStartWorkingTime'
export const CARD_WORKING_END_TIME = 'vcardEndWorkingTime'
export const COMMENT = 'comment'
export const NAME = 'firstname'
export const EMAIL = 'email'
export const PHONE = 'phone'
export const COMPANY_NAME = 'companyName'
export const SITE_URL = 'siteUrl'
export const AGREEMENT = 'dataProcessingPermission'
